<div *ngIf="serviceList" class="request-service-list">
    <span class="request-service-list-title">
        {{'pt.edp.edponline.requests-and-operations.create-request.select-service.title' | translate }}
    </span>
    <ng-container *ngFor="let service of serviceList">
        <request-service-card
                class="request-service-card"
                [serviceInfo]="service"
                [selected]="cardSelected === service"
                (selectedCard)="selectedCard($event)"
        ></request-service-card>
    </ng-container>
</div>